/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputQueueInfo
 */
export interface OutputQueueInfo {
    /**
     * 
     * @type {string}
     * @memberof OutputQueueInfo
     */
    band: string;
    /**
     * 
     * @type {string}
     * @memberof OutputQueueInfo
     */
    band2?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputQueueInfo
     */
    channel: string;
    /**
     * 
     * @type {string}
     * @memberof OutputQueueInfo
     */
    channel2?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputQueueInfo
     */
    comment: string;
    /**
     * 
     * @type {string}
     * @memberof OutputQueueInfo
     */
    connectionType?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputQueueInfo
     */
    controlFrequency: string;
    /**
     * 
     * @type {number}
     * @memberof OutputQueueInfo
     */
    freq: number;
    /**
     * 
     * @type {number}
     * @memberof OutputQueueInfo
     */
    freq2?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputQueueInfo
     */
    missionType: string;
    /**
     * 
     * @type {string}
     * @memberof OutputQueueInfo
     */
    queuedAt: string;
    /**
     * 
     * @type {string}
     * @memberof OutputQueueInfo
     */
    repeaterChannel?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputQueueInfo
     */
    team: number;
    /**
     * 
     * @type {string}
     * @memberof OutputQueueInfo
     */
    teamName: string;
}

/**
 * Check if a given object implements the OutputQueueInfo interface.
 */
export function instanceOfOutputQueueInfo(value: object): boolean {
    if (!('band' in value)) return false;
    if (!('channel' in value)) return false;
    if (!('comment' in value)) return false;
    if (!('controlFrequency' in value)) return false;
    if (!('freq' in value)) return false;
    if (!('missionType' in value)) return false;
    if (!('queuedAt' in value)) return false;
    if (!('team' in value)) return false;
    if (!('teamName' in value)) return false;
    return true;
}

export function OutputQueueInfoFromJSON(json: any): OutputQueueInfo {
    return OutputQueueInfoFromJSONTyped(json, false);
}

export function OutputQueueInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputQueueInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'band': json['band'],
        'band2': json['band2'] == null ? undefined : json['band2'],
        'channel': json['channel'],
        'channel2': json['channel2'] == null ? undefined : json['channel2'],
        'comment': json['comment'],
        'connectionType': json['connectionType'] == null ? undefined : json['connectionType'],
        'controlFrequency': json['controlFrequency'],
        'freq': json['freq'],
        'freq2': json['freq2'] == null ? undefined : json['freq2'],
        'missionType': json['missionType'],
        'queuedAt': json['queuedAt'],
        'repeaterChannel': json['repeaterChannel'] == null ? undefined : json['repeaterChannel'],
        'team': json['team'],
        'teamName': json['teamName'],
    };
}

export function OutputQueueInfoToJSON(value?: OutputQueueInfo | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'band': value['band'],
        'band2': value['band2'],
        'channel': value['channel'],
        'channel2': value['channel2'],
        'comment': value['comment'],
        'connectionType': value['connectionType'],
        'controlFrequency': value['controlFrequency'],
        'freq': value['freq'],
        'freq2': value['freq2'],
        'missionType': value['missionType'],
        'queuedAt': value['queuedAt'],
        'repeaterChannel': value['repeaterChannel'],
        'team': value['team'],
        'teamName': value['teamName'],
    };
}

